import React, { PureComponent } from "react";
import { bool, string, func, oneOfType, number } from "prop-types";
import classNames from "classnames";
import MaskedInput from "react-text-mask";

import getMaskProps from "./utils/getMaskProps";

export default class TextField extends PureComponent {
	static propTypes = {
		id: string.isRequired,
		placeholder: string.isRequired,
		type: string,
		hasError: bool,
		errorMessage: string,
		onChangeHook: func,
		maskType: (props, propName, componentName) => {
			const maskType = props[propName];

			if (
				!maskType ||
				typeof maskType === "function" ||
				getMaskProps(maskType)
			)
				return null;

			return new Error(
				`Invalid prop ${propName} supplied to ${componentName}.` +
					`${propName} should match a predefined type or be a custom function.`
			);
		},
		guide: bool,
		keepCharPositions: bool,
		value: oneOfType([string, number]),
		onBlurHandler: func
	};

	static defaultProps = {
		type: "text",
		hasError: false,
		errorMessage: "",
		onChangeHook: undefined,
		maskType: "",
		guide: false,
		keepCharPositions: true
	};

	state = { hasValue: false };

	componentWillMount() {
		if (this.props.value) this.setState({ hasValue: true });
	}

	onBlur = event => {
		this.setState({ hasValue: !!event.currentTarget.value });
		if (this.props.onBlurHandler) this.props.onBlurHandler();
	};

	onChange = event => {
		const { onChangeHook } = this.props;

		if (onChangeHook) onChangeHook(event);

		this.setState({ hasValue: !!event.currentTarget.value });
	};

	getInputClasses() {
		if (!this.state.hasValue) return "fl-input";

		const { hasError } = this.props;

		return classNames("fl-input", {
			"fl-valid": !hasError,
			"fl-invalid": hasError
		});
	}

	renderInput() {
		const {
			id,
			placeholder,
			hasError,
			errorMessage,
			onChangeHook,
			maskType,
			guide,
			keepCharPositions,
			...rest
		} = this.props;

		const inputProps = {
			id,
			onBlur: this.onBlur,
			onChange: this.onChange,
			className: this.getInputClasses(),
			...rest
		};

		if (maskType) {
			const maskProps = Object.assign({}, getMaskProps(maskType), {
				guide,
				keepCharPositions
			});

			return <MaskedInput {...maskProps} {...inputProps} />;
		}

		return <input {...inputProps} />;
	}

	renderErrorMessage() {
		const { hasError, errorMessage } = this.props;

		if (!hasError || !errorMessage) return null;

		return <span className="fl-error-msg">{errorMessage}</span>;
	}

	render() {
		const { id, placeholder } = this.props;
		if (this.props.maskType === "dollars")
			return (
				<div className="fl-input-container">
					{this.renderInput()}
					{this.renderErrorMessage()}
				</div>
			);
		return (
			<div className="fl-input-container">
				{this.renderInput()}
				<label className="fl-input-label" htmlFor={id}>
					{placeholder}
				</label>
				{this.renderErrorMessage()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/TextField/index.jsx